import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { useDeleteConcept } from "@/hooks/useConcepts";
import type { ConceptListItem } from "@/types/concept";

interface Props {
  concept: ConceptListItem | null;
  onClose: () => void;
}

export function DeleteConceptDialog({ concept, onClose }: Props) {
  const deleteConcept = useDeleteConcept();

  async function handleDelete() {
    if (!concept) return;
    await deleteConcept.mutateAsync(concept.id);
    onClose();
  }

  return (
    <Dialog open={!!concept} onOpenChange={(v) => !v && onClose()}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Delete Concept</DialogTitle>
          <DialogDescription>
            Are you sure you want to delete "{concept?.name}"? This will remove
            all associated papers and cannot be undone.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>
            Cancel
          </Button>
          <Button
            variant="destructive"
            onClick={handleDelete}
            disabled={deleteConcept.isPending}
          >
            {deleteConcept.isPending ? "Deleting..." : "Delete"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
